import { render, staticRenderFns } from "./PanelKecelakaan.vue?vue&type=template&id=e119aea4&scoped=true"
import script from "./PanelKecelakaan.vue?vue&type=script&lang=js"
export * from "./PanelKecelakaan.vue?vue&type=script&lang=js"
import style0 from "./PanelKecelakaan.vue?vue&type=style&index=0&id=e119aea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e119aea4",
  null
  
)

export default component.exports